<template>
  <div class="container" v-wechat-title="$route.meta.title">

    <!-- 营销报表 -->
    <div class="onePart">
     <div v-if="changeIndex == 0" v-bind:class="{ day:changeIndex== 0,'date-bar':1}">{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'m')}} <span @click="selectDate('add')">&gt;&gt;</span></div>
      <div v-if="changeIndex == 1" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'d')}} - {{showDate(endDay,'d')}} <span @click="selectDate('add')">&gt;&gt;</span></div>

      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>
        <div @click="changeType" :index="1" :class="[changeIndex==1?'div1':'div2']">周报</div>
        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative"><label v-if="changeIndex == 0">今日</label>优惠券发放数量（张）
            <p v-if="changeIndex == 0" @click="checkQues('今日优惠券发放数量_'+(changeIndex+1))" class="ques"></p>
            <p v-if="changeIndex != 0" @click="checkQues('优惠券发放数量_'+(changeIndex+1))" class="ques"></p>
          </div>
          <div>{{getOneDimension("优惠券发放总数量",0)}}</div>
          <div v-if="changeIndex == 0">昨日：{{getOneDimension("昨日优惠券发放总数量",0)}}</div>
        </div>
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative"><label v-if="changeIndex == 0">今日</label>拼团成交单数（张）
            <p v-if="changeIndex == 0" @click="checkQues('今日拼团成交单数_'+(changeIndex+1))" class="ques"></p>
            <p v-if="changeIndex != 0" @click="checkQues('拼团成交单数_'+(changeIndex+1))" class="ques"></p>
          </div>
          <div>{{getOneDimension("拼团成交总单数",0)}}</div>
          <div v-if="changeIndex == 0">昨日：{{getOneDimension("昨日拼团成交总单数",0)}}</div>
        </div>
        <div class="info info_1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative"><label v-if="changeIndex == 0">今日</label>秒杀成交单数（张）
            <p v-if="changeIndex == 0" @click="checkQues('今日秒杀成交单数_'+(changeIndex+1))" class="ques"></p>
            <p v-if="changeIndex != 0" @click="checkQues('秒杀成交单数_'+(changeIndex+1))" class="ques"></p>
          </div>
          <div>{{getOneDimension("秒杀成交总单数",0)}}</div>
          <div v-if="changeIndex == 0">昨日：{{getOneDimension("昨日秒杀成交总单数",0)}}</div>
        </div>
      </div>
    </div>
    <!-- 优惠券发放分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        优惠券发放分布<p @click="checkQues('优惠券发放分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <div class="onePart" v-if="changeIndex != 0">
      <!-- <div v-if="changeIndex != 0" class="titlePart disp-just-flsta-ali-cen">
        单日优惠券发放数量
      </div> -->
      
      <div class="table-box" >
        <div class="titlePart disp-just-flsta-ali-cen div-relative">
          单日优惠券发放数量<p @click="checkQues('单日优惠券发放数量_'+(changeIndex+1))" class="ques2"></p>
        </div>
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getCouponByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getCouponByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 优惠券核销分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        优惠券核销分布<p @click="checkQues('优惠券核销分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <div class="onePart" v-if="changeIndex != 0">
      <!-- <div class="titlePart disp-just-flsta-ali-cen">
        单日优惠券核销数量
      </div> -->
      <div class="table-box" >
        <div class="titlePart disp-just-flsta-ali-cen div-relative">
        单日优惠券核销数量<p @click="checkQues('会员类型占比_'+(changeIndex+1))" class="ques2"></p>
      </div>
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getCouponVerificationByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getCouponVerificationByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 秒杀成交分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        秒杀成交分布<p @click="checkQues('秒杀成交分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieThree" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <div class="onePart" v-if="changeIndex != 0">  
      <div class="table-box" >
        <div v-if="changeIndex != 0" class="titlePart disp-just-flsta-ali-cen div-relative">
          单日秒杀成交数量<p @click="checkQues('单日秒杀成交数量_'+(changeIndex+1))" class="ques2"></p>
        </div>
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getSeckillByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getSeckillByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 秒杀核销分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        秒杀核销分布<p @click="checkQues('秒杀核销分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieFour" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <div class="onePart" v-if="changeIndex != 0">
      <div class="table-box" >
        <div v-if="changeIndex != 0" class="titlePart disp-just-flsta-ali-cen div-relative">
          单日秒杀核销数量<p @click="checkQues('单日秒杀核销数量_'+(changeIndex+1))" class="ques2"></p>
        </div>
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getSeckillVerificationByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getSeckillVerificationByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 拼团成交分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        拼团成交分布<p @click="checkQues('拼团成交分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieFive" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <div class="onePart" v-if="changeIndex != 0">  
      <div v-if="changeIndex != 0" class="titlePart disp-just-flsta-ali-cen div-relative">
        单日拼团成交数量<p @click="checkQues('单日拼团成交数量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box" >
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getGroupByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getGroupByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 拼团核销分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        拼团核销分布<p @click="checkQues('拼团核销分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieSix" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <div class="onePart" v-if="changeIndex != 0">
      <div v-if="changeIndex != 0" class="titlePart disp-just-flsta-ali-cen div-relative">
        单日拼团核销数量<p @click="checkQues('单日拼团核销数量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box" >
        <div class="table-div table-div2 ">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getGroupVerificationByDay">
              <td v-if="j == 0" :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table v-if="changeIndex != 0" class="data-table" width="100%" border="1" align="center" cellspacing="0" cellpadding="0">
            <tr v-for="(item,i) in getGroupVerificationByDay">
              <td :class="[i==0?'thClass':'tdClass']" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
     <div class="divPlaceholder">&nbsp;</div>
   <!-- loading的显示隐藏 -->
    <!-- <van-popup :close-on-click-overlay="false" v-model="loadShow">
      <van-loading size="0px" vertical><img src="../assets/indexImage/caiwu@2x.png"></img>加载中...</van-loading>
    </!-->
    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
  </div>
</template>
<script>
  import Vue from 'vue'
  import util from '../../static/js/util'
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  import baseUrl from '../../static/js/basedata.js'
  import {
    Loading
  } from 'vant';
  Vue.use(Loading);

  export default {
    name: 'InfoPage',
    data() {
      return {
        changeIndex: 0,
        beginDay: new Date(),
        endDay: new Date(),
        RptData: {},
        loadShow: false,
        show: false,
        minDate: new Date(),
        maxDate: new Date(2999, 1, 1),
        isPopupShow: false,
        keyWord:'',//带入组件关键字
        popupIsShow:false,
        popupShow:false,//底部弹框是否显示
        keyWords:'',
        popupTitle:'弹框标题',//弹框标题
        popupContent:'弹框内容',//弹框标题
      }
    },
    computed: {
      getDate: function() {
        if (this.changeIndex == 0) {
          return this.formatDate(new Date(this.beginDay));
        } else {
          return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(new Date(this.endDay))}`
        }
      },
      getCouponByDay: function () {
        var para = { X: "优惠券", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日优惠券发放数量", para);
        return rst;
      },
      getCouponVerificationByDay: function () {
        var para = { X: "优惠券", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日优惠券核销数量", para);
        return rst;
      },
      getSeckillByDay: function () {
        var para = { X: "秒杀活动", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日秒杀成交数量", para);
        return rst;
      },
      getSeckillVerificationByDay: function () {
        var para = { X: "秒杀活动", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日秒杀核销数量", para);
        return rst;
      },
      getGroupByDay: function () {
        var para = { X: "拼团活动", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日拼团成交数量", para);
        return rst;
      },
      getGroupVerificationByDay: function () {
        var para = { X: "拼团活动", Y: new Date(this.beginDay).format("MM-dd"), Z: 0 };
        var rst=  this.$util.getThreeDimensionTable(this.RptData.Items, "单日拼团核销数量", para);
        return rst;
      },
    },
    methods: {
      checkQues(_key){
        console.log(_key)
        this.isPopupShow = true;
        this.keyWord = _key;
        this.popupIsShow = true;
      },
      childReturn(data){
        console.log('data-----',data)
        this.isPopupShow = data;
        this.popupIsShow = data;
      },
      formatDate(date) {
        // 今日选择
        if(this.changeIndex == 0){
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }else if(this.changeIndex == 1){
          // 周选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }else if(this.changeIndex == 2){
          // 月选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }
      },
       showDate(date, mode) {
        // 今日选择
        mode = mode || 'a';
        date = new Date(date);
        if (this.changeIndex == 0) {
          return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 1) {
           if (mode === 'y') {
          return `${date.getFullYear()}年`;
        }
        if (mode === 'd')
          return `${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 2) {
          // 月选择
          if (mode === 'y') {
            return `${date.getFullYear()}年`;
          }
          if (mode === 'm')
            return `${date.getMonth() + 1}月`;
        }
      },
      selectDate(mode) {
        if (this.changeIndex == 2) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() + 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() - 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
        if (this.changeIndex == 1) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate()+7);            
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() - 7);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
      },
      onConfirm(date) {
        if(this.changeIndex == 0){
          this.beginDay = date.format("yyyy-MM-dd");
          this.endDay = date.format("yyyy-MM-dd");
        }else {
          const [start, end] = date;
          this.beginDay = start.format("yyyy-MM-dd");
          this.endDay = end.format("yyyy-MM-dd");
        } 
        this.loadData();
      },
      changeType(e){
        var index = e.target.getAttribute('index');
        this.changeIndex = Number(index);
        var date =  this.$dateUtil.today();
        switch (this.changeIndex) {
          case 0:
            date = this.$dateUtil.today();
            break;
          case 1:
            date = this.$dateUtil.thisWeek();
            break;
          case 2:
            date = this.$dateUtil.thisMonth();
            break;
        }
        this.beginDay = date.Begin;
        this.endDay = date.End;
        this.loadData();
      },
      loadData() {
        var that = this;
        that.loadShow = true;
        that.show = false;
        var query = {
          ReportType : that.$util.AppReportType.营销报表,
          Begin: that.beginDay,
          End:that.endDay
        };
        this.$api.get("/AppReport", query, function (res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        }, function (err) { that.loadShow = false; });
      },
      getOneDimension(subTypeName,def) {
        return this.$util.getOneDimension(this.RptData.Items, subTypeName, def);
      },
      getTwoDimension(subTypeName, defX, defY) {
        return this.$util.getTwoDimension(this.RptData.Items, subTypeName, defX, defY);
      },
      getTwoDimensionBar(subTypeName, defY, defValue,valueColumn) {
        return this.$util.getTwoDimensionBar(this.RptData.Items, subTypeName, defY, defValue,valueColumn);
      },
      drawPie() {

        var pieOneData = this.getTwoDimension("优惠券发放数量", "优惠券", "0");
        this.$echarts.init(document.getElementById('pieOne')).setOption(this.$util.PieOption(pieOneData,'张'));

        var pieTwoData = this.getTwoDimension("优惠券核销数量", "优惠券", "0");
        this.$echarts.init(document.getElementById('pieTwo')).setOption(this.$util.PieOption(pieTwoData,'张'));

        var pieThreeData = this.getTwoDimension("秒杀成交数量", "秒杀活动", "0");
        this.$echarts.init(document.getElementById('pieThree')).setOption(this.$util.PieOption(pieThreeData,'次'));

        var pieFourData = this.getTwoDimension("秒杀核销数量", "秒杀活动", "0");
        this.$echarts.init(document.getElementById('pieFour')).setOption(this.$util.PieOption(pieFourData,'次'));

        var pieFiveData = this.getTwoDimension("拼团成交数量", "拼团活动", "0");
        this.$echarts.init(document.getElementById('pieFive')).setOption(this.$util.PieOption(pieFiveData,'次'));

        var pieSixData = this.getTwoDimension("拼团核销数量", "拼团活动", "0");
        this.$echarts.init(document.getElementById('pieSix')).setOption(this.$util.PieOption(pieSixData,'次'));
         

      }
    },
    mounted() {
     var date = this.$dateUtil.today();
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
       phoneDevice.setTitle(this.$route.meta.title || "");
    }
  }
</script>

<style>
@import url("../../static/css/common.css");
  table{
    border: 0.01rem solid #ECECEC;
  }
  .thClass{
    text-align: center;
    height: 1rem;
    color: #999999;
    font-size: 0.32rem;
  }
  .tdClass{
    text-align: center;
    height: 1rem;
    font-size: 0.32rem;
  }
  .topChange{
    width: 100%;
    margin-bottom: 0.53rem;
  }
  .topChange .div1{
    width: auto;
    font-size: 0.34rem;
    color: #1C1C1C;
    border-bottom: 0.05rem solid #1699E5;
  }
  .topChange .div2{
    width: auto;
    font-size: 0.34rem;
    color: #999999;
    border-bottom: 0.05rem solid transparent;
  }
  .container {
    width: 10rem;
    min-height: 100vh;
    background: #f2f2f2;
    /* background: pink; */
    padding: 0 0.34rem;
    box-sizing: border-box;
    border-top: 0.01rem solid transparent;
  }

  .onePart {
    width: 9.33rem;
    background: white;
    border-radius: 0.29rem;
    padding: 0.2rem 0;
    /* height: 3.86rem; */
    margin-top: 0.3rem;
    /* border: 0.05rem solid red; */
  }

  .titlePart {
    width: 100%;
    padding: 0.26rem;
    box-sizing: border-box;
    font-size: 0.32rem;
    color: #1C1C1C;
  }

  .titlePart img {
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.26rem;
  }

  .wrap {
    width: 100%;
    flex-wrap: wrap;
    padding: 0.3rem;
  }

  .wrap .info {
    width: 4.2rem;
    height: 2.4rem;
    background-size: 100%;
    background-repeat: no-repeat;
    color: white;
    padding: 0.2rem;
    /* margin: 0 0.3rem; */
    margin-bottom: 0.26rem;
    box-sizing: border-box;
  }

  .wrap .info1 {
    background-image: url(../assets/indexImage/img10.png);
  }

  .wrap .info_1 {
    background-image: url(../assets/indexImage/img10.png);
    background-position: center;
    background-size: cover;
  }

  .wrap .info2 {
    background-image: url(../assets/indexImage/img2.png);
  }

  .wrap .info3 {
    background-image: url(../assets/indexImage/img4.png);
  }

  .wrap .info4 {
    background-image: url(../assets/indexImage/img6.png);
  }

  .wrap .info5 {
    background-image: url(../assets/indexImage/img12.png);
  }

  .wrap .info6 {
    background-image: url(../assets/indexImage/img8.png);
  }

  .wrap .info div {
    width: 100%;
    text-align: center;
    white-space:inherit;
  }

  .wrap .info div:first-child {
    font-size: 0.32rem;
  }

  .wrap .info div:nth-child(2) {
    font-size: 0.5rem;
    font-weight: bold;
    text-align: center;
  }

  .wrap .info div:nth-child(3) {
    font-size: 0.32rem;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/yingxiaobaobiao.vue